import { useState, useEffect } from 'react';
import styles from './LoginModal.module.css';
import { googleIcon } from '../../assets/icons';

const GOOGLE_OAUTH_URL: string = "https://accounts.google.com/o/oauth2/v2/auth";
const GOOGLE_CLIENT_ID: string = "603186682233-s5kgi61pdeenq8angvee9gu9c7rj7uh4.apps.googleusercontent.com";
const GOOGLE_SCOPES: string[] = ["userinfo.profile", "userinfo.email"];

interface LoginModalProps {
  redirectParams?: Record<string, string>;
  onClose?: () => void;
}

const encodeGoogleScope = (scopes: string[]): string => {
  const fullScopes: string[] = scopes.map(scope => `https://www.googleapis.com/auth/${scope}`);
  return encodeURIComponent(fullScopes.join(' '));
};

const generateGoogleOAuthUrl = (state?: string): string => {
  const redirectUri: string = `${window.location.origin}/oauth/google`;
  const encodedRedirectUri: string = encodeURIComponent(redirectUri);
  const encodedScopes: string = encodeGoogleScope(GOOGLE_SCOPES);
  
  let url = `${GOOGLE_OAUTH_URL}?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=${encodedScopes}`;
  
  // Add state parameter if provided
  if (state) {
    url += `&state=${encodeURIComponent(state)}`;
  }
  
  return url;
};

export default function LoginModal({ 
  redirectParams, 
  onClose 
}: LoginModalProps): JSX.Element {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [stateParam, setStateParam] = useState<string | null>(null);
  
  // Set state parameter from redirectParams if provided
  useEffect(() => {
    if (redirectParams) {
      setStateParam(JSON.stringify(redirectParams));
    }
  }, [redirectParams]);

  const handleGoogleSignIn = (): void => {
    setIsLoading(true);
    try {
      window.location.href = generateGoogleOAuthUrl(stateParam || undefined);
    } catch (error) {
      console.error('Error initiating Google sign-in:', error);
      setIsLoading(false);
    }
  };

  // Render the modal with or without overlay based on inline prop
  const renderContent = (): JSX.Element => (
    <div className={styles.loginCard} onClick={(e) => e.stopPropagation()}>
      <div className={styles.logoContainer}>
        <img src="/media/favicon-512x512.png" alt="HangJam Logo" className={styles.logo} />
      </div>
      <h2>hangjam</h2>
      
      <div className={styles.authButtons}>
        <button 
          onClick={handleGoogleSignIn} 
          className={`${styles.authButton} ${styles.googleButton}`}
          disabled={isLoading}
        >
          <img src={googleIcon} alt="Google" />
          Continue with Google
        </button>
      </div>

      <div className={styles.terms}>
        By continuing, you agree to our{' '}
        <a href="/terms">Terms</a> and acknowledge our{' '}
        <a href="/privacy">Privacy Policy</a>.
      </div>
    </div>
  );

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      {renderContent()}
    </div>
  );
} 